import React from 'react';
import FormatUtils from 'utils/format';
import { Box, Flex } from '@spothero/ui';
// This is a jsx-ified version of the function formatRatePrice from src/js/utils/spot.js 🧑‍🍳😙🤌
// TODO refactor all uses of formatRatePrice and deprecate
const DisplayPriceFormatted = ({ price, currencyType, hideCents = false, textToAppend = '', }) => {
    const { dollars, cents } = FormatUtils.price(Number(price));
    if (textToAppend) {
        return (<Flex alignItems="center" gap="1" py="1.5">
                <Box fontSize="sm" fontWeight="semibold" color="black">
                    {FormatUtils.currencySymbol(currencyType)}
                </Box>
                <Box>
                    {dollars}
                    {cents && !hideCents && `.${cents}`}
                </Box>
                <Box fontSize="sm" fontWeight="normal" color="black">
                    {textToAppend}
                </Box>
            </Flex>);
    }
    return (<>
            {hideCents ? (FormatUtils.currencySymbol(currencyType)) : (<sup>{FormatUtils.currencySymbol(currencyType)}</sup>)}
            {dollars}
            {cents && !hideCents && <sup>.{cents}</sup>}
        </>);
};
export default DisplayPriceFormatted;
